import 'globals';

(function (pageLoadedQueue) {
    pageLoadedQueue.push(function() {
        if (objectFitVideos) {
            objectFitVideos();
        }
    });
})(window.pageLoadedQueue);
